export const refinanceIncreaseLoanConstants = {
    REFINANCE_INCREASE_GET_STARTED: "REFINANCE_INCREASE_GET_STARTED",
    REFINANCE_INCREASE_GET_STARTED_ERROR: "REFINANCE_INCREASE_GET_STARTED_ERROR",

    REFINANCE_LOAN_LOADING: 'REFINANCE_LOAN_LOADING',
    REFINANCE_LOAN_SUCCESS: 'REFINANCE_LOAN_SUCCESS',
    REFINANCE_LOAN_FAILED: 'REFINANCE_LOAN_FAILED',
    REFINANCE_LOAN_PERSONAL_INFORMATION_REQUEST: 'REFINANCE_LOAN_PERSONAL_INFORMATION_REQUEST',
    REFINANCE_LOAN_FINANCIAL_INFORMATION_REQUEST: 'REFINANCE_LOAN_FINANCIAL_INFORMATION_REQUEST',
    REFINANCE_LOAN_FUNDING_REQUEST: 'REFINANCE_LOAN_FUNDING_REQUEST',
}


// WEBPACK FOOTER //
// ./src/_constants/refinanceIncreaseLoan.constants.js